import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import TrustBadges from '@/components/TrustBadges';
import Services from '@/components/Services';
import CoreValues from '@/components/CoreValues';
import About from '@/components/About';
import ForSchoolsCorporates from '@/components/ForSchoolsCorporates';
import Gallery from '@/components/Gallery';
import ClientLogos from '@/components/ClientLogos';
import PrintQuiz from '@/mini-apps/PrintQuiz';
import LeadMagnets from '@/components/LeadMagnets';
import ROICalculator from '@/components/ROICalculator';
import Blog from '@/components/Blog';
import FAQ from '@/components/FAQ';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';

const Index = () => {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <Navbar />
      <Hero />
      <TrustBadges />
      <Services />
      <CoreValues />
      <About />
      <ForSchoolsCorporates />
      <Gallery />
      <ClientLogos />
      <section id="quiz" className="py-20 bg-muted/30">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <span className="text-[#e85a1f] font-semibold text-sm uppercase tracking-widest">Free Tool</span>
            <h2 className="text-3xl md:text-5xl font-bold mt-3">Not Sure What to Print?</h2>
            <p className="text-foreground/60 mt-4 max-w-xl mx-auto">Take our 30-second quiz and get a personalized recommendation.</p>
          </div>
          <div className="max-w-2xl mx-auto">
            <PrintQuiz embedded />
          </div>
        </div>
      </section>
      <LeadMagnets />
      <ROICalculator />
      <Blog />
      <section className="py-16 bg-[#e85a1f]">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">Want Results Like These?</h2>
          <p className="text-white/80 mb-8 max-w-xl mx-auto">Book a free 15-minute branding audit and see exactly what to improve.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/free-school-branding-audit" className="bg-white text-[#e85a1f] px-8 py-4 rounded-lg font-semibold hover:bg-white/90 transition-colors">School Audit</Link>
            <Link to="/free-corporate-branding-audit" className="bg-white/10 text-white border border-white/30 px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors">Corporate Audit</Link>
          </div>
        </div>
      </section>
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

export default Index;
